var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m5.697 7.526 8.517-3.366c1.063-.42 2.112.638 1.683 1.698l-3.413 8.427c-.483 1.194-2.223 1.032-2.479-.23l-.683-3.373-3.4-.672C4.65 9.759 4.49 8.002 5.697 7.526Zm8.811-2.622L5.991 8.27c-.465.183-.403.858.086.955l3.596.71a.5.5 0 0 1 .393.392l.723 3.569a.5.5 0 0 0 .954.088l3.413-8.427a.5.5 0 0 0-.648-.653Z",
    fill: "currentColor"
  })));
};
export default SvgLocation;